mutation (
  $accessToken: String!
  $previousPassword: String!
  $proposedPassword: String!
) {
  changePassword(
    accessToken: $accessToken
    previousPassword: $previousPassword
    proposedPassword: $proposedPassword
  )
}
